<template>
  <div id="interior-box">
    <h3 class="center">Innenausbau und Möbel</h3>
    <br>
    <p>Wir begleiten Sie beim kompletten Ausbau Ihres Wohnraums. Angefangen bei der Raumaufteilung durch Trockenbauwände und das passende Beleuchtungskonzept bis hin zu schwimmend verlegten Böden aus verschiedensten Materialen wie Fertigparkett, Kork, Laminat oder Vinyl. Des Weiteren fertigen wir individuelle Einbaumöbel wie Wandschränke, begehbare Kleiderschränke, Kommoden, Tische und Bänke, die sich perfekt in Ihre Umgebung einpassen. Dabei richten wir uns ganz nach Ihren Designvorstellungen und Wünschen. So können wir beispielsweise moderne Schubladensysteme mit Dämpfung und Vollauszug oder eine automatische Innenbeleuchtung integrieren. Auch beim Ändern oder Ergänzen bereits bestehender Möbel unterstützen wir Sie gerne. Darüber hinaus können wir Ihnen dabei helfen, ihr Zuhause für das barrierefreie Wohnen umzugestalten. Dafür installieren wir Handläufe, Geländer und Griffe aus Holz, Metall oder Kunststoff und montieren Rampen über Türschwellen, die ganz auf Ihre Bedürfnisse angepasst sind.</p>
    <br>
    <br>

    <h3 class="center">Galerie</h3>
    <br>
    <image-gallery :images="galleryImages"/>
  </div>
</template>

<script>
export default {
  name: "Interior",
  data() {
    return {
      galleryImages:this.importImages()
    };
  },
  methods:{
    importImages(){
      function importAll(r) { return r.keys().sort().map(r); }
      var images = importAll(require.context('@/assets/media/interior', false, /\.(png|jpe?g|svg)$/));
      return images.map(i=>{return {src:i}})
    }
  }
};
</script>

<style>

</style>
